import { useCallback } from 'react';

import { useTracking as useTrackingBase } from '@change-corgi/core/react/tracking';

type Result = {
	trackAmountInputFocus: () => void;
};

export function useTracking(): Result {
	const track = useTrackingBase();

	return {
		trackAmountInputFocus: useCallback(() => {
			void track('pp_focus_amount');
		}, [track]),
	};
}
